(() => {
  if (window.sapCommerceCodes) return;
  window.sapCommerceCodes = true;
  customElements.whenDefined('cart-discount-code').then(() => {
    const prototype = customElements.get('cart-discount-code').prototype;
    const nativeCodes = prototype.existingDiscounts;
    const nativeUpdate = prototype.updateCartContent;
    const nativeMount = prototype.mountComponent;
    const announced = new WeakSet();
    // A rejected code: the input is marked invalid and described by the error, and the error is spoken through a live region that is always on the page.
    const announce = component => {
      if (announced.has(component) || !component.hasAttribute('data-sap-real-codes')) return;
      const error = component.querySelector('[data-cart-discount-error]'), input = component.querySelector('[data-cart-discount-code-input]'), live = component.querySelector('[data-sap-discount-live]'), form = component.querySelector('[data-cart-discount-code-form]');
      if (!error || !input || !live) return;
      announced.add(component);
      const sync = () => {
        const shown = !error.classList.contains('hidden');
        if (shown) { input.setAttribute('aria-invalid', 'true'); input.setAttribute('aria-describedby', error.id); live.textContent = ''; requestAnimationFrame(() => { live.textContent = error.textContent.trim(); }); }
        else { input.removeAttribute('aria-invalid'); input.removeAttribute('aria-describedby'); live.textContent = ''; }
      };
      new MutationObserver(sync).observe(error, { attributes: true, attributeFilter: ['class'] });
      form?.addEventListener('submit', () => error.classList.add('hidden'), true);
      sync();
    };
    // U4 fix 6 (ST-26): Shopify keeps a code on the cart after it stops applying (HELLOPEACE20 after Upgrade on the Full System), but Liquid
    // does not give the theme cart.discount_codes. Read it from Shopify's own cart JSON, once per render, and show each such code as a removable
    // chip with the refusal line the snippet already wrote (announce() then marks the field and speaks it). Codes Liquid already drew are left alone.
    let reading = null;
    const cartCodes = () => reading ||= fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(response => response.ok ? response.json() : null)
      .then(cart => Array.isArray(cart?.discount_codes) ? cart.discount_codes : [])
      .catch(() => [])
      .finally(() => setTimeout(() => { reading = null; }, 0));
    const markRefused = component => {
      if (!component.hasAttribute('data-sap-real-codes')) return;
      cartCodes().then(codes => {
        const template = component.querySelector('template[data-sap-refused-chip]'), list = component.querySelector('.cart-discount-code__applied-codes'), error = component.querySelector('[data-cart-discount-error]');
        if (!component.isConnected || !template || !list || !error) return;
        const drawn = new Set([...component.querySelectorAll('[data-sap-entered-code][data-discount-code]')].map(node => node.dataset.discountCode.trim().toUpperCase()));
        const refused = codes.filter(entry => entry?.applicable === false && typeof entry.code === 'string' && entry.code.trim() && !drawn.has(entry.code.trim().toUpperCase()));
        if (!refused.length) return;
        refused.forEach(entry => {
          const code = entry.code.trim(), chip = template.content.firstElementChild.cloneNode(true), remove = chip.querySelector('[data-remove-discount]');
          chip.dataset.discountCode = code;
          chip.querySelector('[data-sap-code-name]').textContent = code;
          remove.setAttribute('data-remove-discount', code);
          remove.setAttribute('aria-label', remove.getAttribute('aria-label').replace('__SAP_CODE__', code));
          if (typeof component.addListener === 'function') component.addListener(remove, 'click', component.removeDiscount);
          else remove.addEventListener('click', component.removeDiscount);
          list.append(chip);
        });
        list.classList.remove('hidden');
        error.classList.remove('hidden');
      });
    };
    prototype.mountComponent = function () { const result = nativeMount?.call(this); announce(this); markRefused(this); return result; };
    document.querySelectorAll('cart-discount-code').forEach(component => { announce(component); markRefused(component); });
    prototype.existingDiscounts = function () {
      if (!this.hasAttribute('data-sap-real-codes')) return nativeCodes.call(this);
      return [...new Set([...this.querySelectorAll('[data-sap-entered-code][data-discount-code]')].map(node => node.dataset.discountCode.trim()).filter(Boolean))];
    };
    // Post-launch P2-1: a code change on /cart swaps in a new cart-page element (Aurora's own updateCartContent does the same). The header
    // <cart-count> badges subscribe to the cart page's update-nodes event once, when they mount, so they kept listening to the old element and a
    // later item removal left the old count showing. Point every badge at the cart page now on screen, once each.
    const relinkCounts = () => {
      const cart = document.querySelector('cart-page');
      if (!cart || typeof cart.on !== 'function') return;
      const listening = cart.events?.['update-nodes'] || [];
      document.querySelectorAll('cart-count').forEach(count => {
        if (typeof count.handleCartUpdate === 'function' && !listening.includes(count.handleCartUpdate)) cart.on('update-nodes', count.handleCartUpdate);
      });
    };
    prototype.updateCartContent = function (html) {
      if (!this.hasAttribute('data-sap-real-codes')) { const result = nativeUpdate.call(this, html); relinkCounts(); return result; }
      let root = this.cart;
      if (root.matches('cart-page')) {
        const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-page');
        if (!replacement) return;
        root.replaceWith(replacement);
        root = replacement;
        relinkCounts();
      } else {
        const replacement = root.getTemplateContent(new DOMParser().parseFromString(html, 'text/html'));
        if (!replacement) return;
        root.lastDrawerBody = replacement;
        root.emit('update-nodes', { node: replacement });
        root.updateEmptyStatus();
      }
      requestAnimationFrame(() => document.dispatchEvent(new CustomEvent('sap:bag-promo-updated', { detail: { root } })));
    };
  });
})();
